(function($) {
    $(() => {
        var scrollPos = 0;

        $('.filter .label').click(function(){
            $(this).parents('.filter').addClass('is-opened');
        });

        $('.js-toggle-filter').click(function(){
            $('.done__filter_controls').toggleClass('is-opened');
            $('.done__filter_controls').scrollTop(0)
        
            // FIX BODY IF NAVBAR IS OPENED ON MOBILE
            if($('.done__filter_controls').hasClass('is-opened')) {
                scrollPos = $(window).scrollTop();
                $('body').css({
                    overflow: 'hidden',
                    position: 'fixed',
                    width: '100vw',
                    top : -scrollPos
                });
            } else {
                $('body').css({
                    overflow: '',
                    position: 'relative',
                    top: ''
                });
                $(window).scrollTop(scrollPos);
            }

        });

    });
})(jQuery);
